export enum LoadingStateType {
  UPLOADING = 'uploading',
  DELETING = 'deleting',
}
